'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _TextInput = require('./TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultipleTextInput = function (_Component) {
    _inherits(MultipleTextInput, _Component);

    function MultipleTextInput(props) {
        _classCallCheck(this, MultipleTextInput);

        var _this = _possibleConstructorReturn(this, (MultipleTextInput.__proto__ || Object.getPrototypeOf(MultipleTextInput)).call(this, props));

        _this._updateValue = function (data) {
            var newData = [].concat(_toConsumableArray(_this.state.value));

            for (var field in data) {
                // Remove the prefix from the field name
                var index = field.slice(_this.props.name.length + 2);

                newData[index] = data[field];
            }

            _this.props.updateValue(_defineProperty({}, _this.props.name, newData));
        };

        _this._addNewField = function () {
            _this.setState(function (state) {
                return { value: [].concat(_toConsumableArray(state.value), ['']) };
            });
        };

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(MultipleTextInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            }, this.props.extraGroupClasses);

            var fields = null;

            var value = this.state.value.value;


            if (value && value.length) {
                fields = value.map(function (item, index) {
                    return _react2.default.createElement(_TextInput2.default, {
                        controlOnly: true,
                        disabled: _this2.props.disabled,
                        handleBlur: _this2.props.handleBlur,
                        handleFocus: _this2.props.handleFocus,
                        key: index,
                        name: _this2.props.name + '__' + index,
                        type: _this2.props.type,
                        updateValue: _this2._updateValue,
                        value: item
                    });
                });
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    null,
                    this.props.label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form__control' },
                    fields
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'grid grid--break-mobile' },
                    _react2.default.createElement(
                        'div',
                        { className: 'pull-right' },
                        _react2.default.createElement(
                            _Button2.default,
                            {
                                buttonOnly: true,
                                disabled: this.props.disabled,
                                onClick: this._addNewField,
                                status: 'create'
                            },
                            'Add another'
                        )
                    )
                ),
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors, help: this.props.help })
            );
        }
    }]);

    return MultipleTextInput;
}(_react.Component);

MultipleTextInput.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.focussablePropTypes, {

    type: _propTypes2.default.string,
    value: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
});
MultipleTextInput.defaultProps = {
    disabled: false,
    type: 'text'
};
exports.default = MultipleTextInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/MultipleTextInput.js
// module id = 431
// module chunks = 0